import { useState } from 'react'
import moment from 'moment'

import { DatePicker } from '@components/TimePicker'
import { CardSection } from '@components/CardSection'
import Button from '@components/Button'

import { DATE_FORMAT } from 'shared/constants'

import styles from '../styles.module.scss'

const DateSelection = ({ onNext, value, children, onChange, isLoading }) => {
    const [startDate, setStartDate] = useState(value || null)

    const onStartDateChange = momentDate => {
        setStartDate(momentDate)
        if (onChange) {
            onChange(momentDate)
        }
    }

    const onNextClick = () => {
        onNext({ value: startDate, displayValue: startDate.format('L') })
    }

    return (
        <CardSection className={styles.contentSection} loading={false}>
            <h5 className="text-uppercase">
                <T>subscription.purchase.start.on</T>
            </h5>
            <div className="col-sm-4 mt-6 mb-6 px-0">
                <DatePicker
                    label={<T>label.parking.start</T>}
                    value={startDate ? moment(startDate) : ''}
                    displayFormat={DATE_FORMAT}
                    onChange={onStartDateChange}
                />
            </div>
            {children}
            <div className="d-flex justify-content-end">
                <Button btnStyle="primary" onClick={onNextClick} disabled={!startDate || isLoading}>
                    <T>subscription.purchase.label.next</T>
                </Button>
            </div>
        </CardSection>
    )
}

export default DateSelection
